import React from "react";
import { RCCButton, RCCDropDownItem, RCCIcon, RCCTooltip } from "react-common-components";
import CheckPermission from "src/components/CheckPermission";
import DropdownWithBackground from "src/components/DropdownWithBackground";
import SortableHandle from "src/components/Sortable/Handle";
import { PermissionEnum } from "src/context/Auth/interface";
import { useTranslation } from "src/context/Translations/context";
import { ICatbb001 } from "src/pages/BusinessDiagnostics/Canvas/interface";
import Card from "./styles";

interface CanvasCardProps {
	data: ICatbb001;
	selected: boolean;
	disableOptions: boolean;
	openModalChangeCanvas?: (canvas: ICatbb001) => void;
	openModalDeleteCanvas?: (canvas: ICatbb001) => void;
	onClickCardFuncion: (canvas: ICatbb001) => void;
}

const CanvasCard: React.FC<CanvasCardProps> = ({
	data,
	selected,
	disableOptions,
	openModalChangeCanvas,
	openModalDeleteCanvas,
	onClickCardFuncion
}) => {

	const { translate } = useTranslation();

	return (
		<>
			<Card 
				key={data.cab001Id} 
				onClick={(e) => {e.stopPropagation(); onClickCardFuncion(data);}} 
				selected={selected}
				disableOptions={disableOptions}
				color="var(--purple)"
			>
				<CheckPermission minimumPermissionRequired={PermissionEnum.CREATE_UPDATE}>
					<div className="card-head">
						<span className="icon-options">
							<div className="card-canvas-options-move">
								<SortableHandle>
									<RCCTooltip 
										color="purple"
										text={translate("Mover Canvas")}
									>
										<RCCButton
											color="transparent"
											icon={{
												name: "arrows",
												color: selected ? "#FFF" : "var(--grey)"
											}}
											layout="isRounded"
											onClick={(e) => e.stopPropagation()}
										/>
									</RCCTooltip>	
								</SortableHandle>
							</div>
							<DropdownWithBackground
								position="left"
								useStopPropagation
								callerComponent={
									<RCCButton
										color="transparent"
									>
										<RCCIcon name="dotsVertical" size={18} color={selected ? "#FFF" : "var(--grey)"}/>
									</RCCButton>
								}
							>
								<RCCDropDownItem
									selfEnclose
									onClick={(e) => { e.stopPropagation(); if(!openModalChangeCanvas) return; openModalChangeCanvas(data);}}
								>
									<RCCIcon name="pencil" />
									{translate("Alterar")}
								</RCCDropDownItem>
								<CheckPermission minimumPermissionRequired={PermissionEnum.CREATE_UPDATE_DELETE}>
									<RCCDropDownItem
										selfEnclose
										onClick={(e) => { e.stopPropagation(); if(!openModalDeleteCanvas) return; openModalDeleteCanvas(data);}}
									>
										<RCCIcon name="trash" />
										{translate("Excluir")}
									</RCCDropDownItem>								
								</CheckPermission>
							</DropdownWithBackground>
						</span>
					</div>												
				</CheckPermission>
			
				<div className="card-body"><span title={data.cab001Descricao}>{data.cab001Descricao}</span></div>
				<div className="card-footer"><span title={data.caa001Descricao}>{data.caa001Descricao}</span></div>
			</Card>
		</>
	);
};

export default CanvasCard;
